import { Box } from "@material-ui/core";
import { ReactNode } from "react";

interface TabPanelProps {
  children: ReactNode;
  index: number;
  value: number;
  id?: string;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, id } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={id ?? `tab-panel-${index}`}
      aria-labelledby={id ?? `tab-panel-${index}`}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

export default TabPanel;
